import { CSSProperties } from "react";
import { DragSide } from "./geometry";

export const noSelect: CSSProperties = {
  WebkitTouchCallout: "none",
    WebkitUserSelect: "none", /* Safari */
     KhtmlUserSelect: "none", /* Konqueror HTML */
       MozUserSelect: "none", /* Old versions of Firefox */
        msUserSelect: "none", /* Internet Explorer/Edge */
          userSelect: "none",
};

export const INSERT_SHIFT = 40;

export const addSideStyle = (st: CSSProperties, side?: DragSide): CSSProperties => ({
    ...st,
    transform: side === DragSide.left
    ? `translateX(${INSERT_SHIFT}px)`
    : side === DragSide.right
    ? `translateX(-${INSERT_SHIFT}px)`
    : side === DragSide.top
    ? `translateY(${INSERT_SHIFT}px)`
    : side === DragSide.bottom
    ? `translateY(-${INSERT_SHIFT}px)`
    : "none",
    transition: "transform 0.5s",
  });

